<template>
  <div>
    <van-nav-bar title="" left-text="back" left-arrow @click-left="onClickLeft" />
    <div id="app">
      <div class="list-box">
        <div class="title">BASIC INFO</div>
        <div>
          <div class="font-16 left-text">FULL NAME</div>
          <van-cell-group> <van-field v-model="form.fullName" :border="true" /></van-cell-group>
        </div>
        <!-- <div>
        <div class="font-16 left-text">EMAIL</div>
        <van-cell-group> <van-field :border="true" v-model="form.email" /></van-cell-group>
      </div> -->
        <div class="flex margin-top-16">
          <div class="font-16 left-text margin-right-10">GENDER</div>
          <van-radio-group v-model="form.sex" direction="horizontal">
            <van-radio :name="1" checked-color="#FF5D00">Male</van-radio>
            <van-radio :name="2" checked-color="#FF5D00">Female</van-radio>
          </van-radio-group>
        </div>
        <!-- <div class="margin-top-16">
        <div class="font-16 left-text">DATE OF BIRTH</div>
        <van-cell-group> <van-field readonly :border="true" v-model="form.birthday" @click="show = true"
            right-icon="https://imgs.hdjfg.com/gift/img/datetime.png" /></van-cell-group>
      </div> -->
        <div class="title">ADDITIONAL INFO</div>
        <div>
          <div class="font-16 left-text">PAN CARD</div>
          <van-cell-group> <van-field :border="true" v-model="form.panCard" /></van-cell-group>
        </div>
        <!-- <div>
          <div class="font-16 left-text">ADDHAAR NUMBER</div>
          <van-cell-group> <van-field :border="true" v-model="form.aadhaarNumber" /></van-cell-group>
        </div> -->

        <div>
          <div class="font-16 left-text">ADDRESS</div>
          <van-cell-group> <van-field :border="true" v-model="form.address" /></van-cell-group>
        </div>

        <!-- <div>
          <div class="font-16 left-text">POSTCODE</div>
          <van-cell-group> <van-field :border="true" v-model="form.postcode" /></van-cell-group>
        </div> -->

        <!-- <div>
          <div class="font-16 left-text">CITY</div>
          <van-cell-group> <van-field :border="true" v-model="form.city" /></van-cell-group>
        </div> -->

        <!-- <div>
          <div class="font-16 left-text">STATES</div>
          <van-cell-group> <van-field :border="true" v-model="form.states" /></van-cell-group>
        </div> -->

        <!-- <div>
          <div class="font-16 left-text">MARITAL STATUS</div>
          <van-cell-group> <van-field :border="true" v-model="form.maritalStatus" /></van-cell-group>
        </div> -->

        <div>
          <div class="font-16 left-text">AGE</div>
          <van-cell-group> <van-field :border="true" v-model="form.age" /></van-cell-group>
        </div>

        <!-- <div>
          <div class="font-16 left-text">RELIGION</div>
          <van-cell-group> <van-field :border="true" v-model="form.religion" /></van-cell-group>
        </div> -->
        <div>
          <div class="font-16 left-text">FACEBOOK ACCOUNT</div>
          <van-cell-group> <van-field :border="true" v-model="form.facebook_account" /></van-cell-group>
        </div>

      </div>
      <div class="fixed repay-box margin-top-30 ">
        <div class="theme-back repay" @click="editInfo">
          NEXT
        </div>
      </div>


      <van-popup v-model="show" position="bottom" round :style="{ height: '30%' }">
        <van-datetime-picker v-model="currentDate" type="date" title="select" :min-date="minDate" :max-date="maxDate"
          confirm-button-text="confirm" cancel-button-text="cancel" @cancel="show = false" @confirm="confirm" />
      </van-popup>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        fullName: '',
        // email: '',
        sex: '',
        panCard: '',
        // aadhaarNumber: '',
        // accommodation: '',
        address: '',
        // postcode: '',
        // city: '',
        // states: '',
        // maritalStatus: '',
        age: '',
        // religion: '',
        facebook_account: '',
        // birthday: '',
      },
      show: false,
      minDate: new Date('1900/1/1'),
      maxDate: new Date('2025/10/1'),
      currentDate: new Date(),
    }
  },
  created() {

  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    confirm(value) {
      console.log(value)
      this.form.birthday = value.getFullYear() + "-" + (value.getMonth() + 1) + "-" + value.getDate()
      this.show = false
    },
    async editInfo() {
      const { data: res } = await this.$http.post('/api/user/editInfo', this.form)
      if (res.code === 0) {
        this.$router.push({
          name: 'companydetails'
        })
      } else {
        this.$toast(res.msg)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.van-cell {
  padding: 14px 0px;
}

#app {
  background: #F9F9F9;
  min-height: 100vh;
  padding: 12px 12px 30px 12px;
  box-sizing: border-box;


  .list-box {
    margin-bottom: 67px;
    background: #FFFFFF;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1);
    border-radius: 14px;
    padding: 13px 14px;
  }


  .title {
    font-size: 15px;
    color: #FFA06A;
    font-weight: 500;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .left-text {
    color: #101010;
  }

  .repay-box {
    bottom: 10px;
    margin: 0 auto;
    left: 0;
    right: 0;
    width: 299px;

    .repay {
      padding: 12px 128px;
      font-size: 16px;
      color: #FFFFFF;
      font-weight: bold;
      border-radius: 24px;
    }
  }

}
</style>
